import request from '@/utils/request'


// 查询客服人员列表
export function listCustomerStaff(query) {
  return request({
    url: '/biz/admin/customer/staff/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询客服人员分页
export function pageCustomerStaff(query) {
  return request({
    url: '/biz/admin/customer/staff/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询客服人员详细
export function getCustomerStaff(data) {
  return request({
    url: '/biz/admin/customer/staff/detail',
    method: 'get',
    params: data
  })
}


export function openCustomerWork(data) {
  return request({
    url: '/biz/admin/customer/staff/open-customer-work',
    method: 'get',
    params: data
  })
}



// 新增客服人员
export function addCustomerStaff(data) {
  return request({
    url: '/biz/admin/customer/staff/add',
    method: 'post',
    data: data
  })
}

// 修改客服人员
export function updateCustomerStaff(data) {
  return request({
    url: '/biz/admin/customer/staff/edit',
    method: 'post',
    data: data
  })
}

// 删除客服人员
export function delCustomerStaff(data) {
  return request({
    url: '/biz/admin/customer/staff/delete',
    method: 'post',
    data: data
  })
}




export function syncImUser(query) {
  return request({
    url: '/biz/admin/customer/staff/im/sync',
    method: 'get',
    params: query
  })
}